// extracted by mini-css-extract-plugin
module.exports = {"root":"Cell_root__2ti8K","empty":"Cell_empty__1ByI9","seen":"Cell_seen__2qSTX","visible":"Cell_visible__2bnT3","unknown":"Cell_unknown__2tYkG"};